import type { FieldSchemaModel } from '@/shared/generated'
import type { ChangeEvent } from 'react'

import React, { useState } from 'react'

import {
	InlineEdit,
	InlineEditInput,
	InlineEditTrigger,
} from '@/shared/components/ui/inline-edit'
import { Input } from '@/shared/components/ui/input'
import { cn } from '@/shared/lib/utils'

import { BasicTextField } from './BasicTextField'

export function BasicTextEditorField(props: {
	value: string
	isDirty: boolean
	onChange: (value: string | null) => void
	field?: FieldSchemaModel
}) {
	const [editValue, setEditValue] = useState<string | null>(props.value)
	const isEdited = !!props?.isDirty

	const onChange = (event: ChangeEvent<HTMLInputElement>) =>
		setEditValue(event.target.value || null)

	const onConfirm = () => {
		if (editValue === props.value) {
			return
		}
		props.onChange?.(editValue)
		setEditValue(null)
	}

	return (
		<InlineEdit onConfirm={onConfirm}>
			<InlineEditTrigger className={cn({ 'text-primary': isEdited })}>
				<div>
					<BasicTextField {...props} value={props.value} />
				</div>
			</InlineEditTrigger>
			<InlineEditInput>
				<Input
					defaultValue={props.value as string}
					value={editValue as string}
					autoFocus
					onChange={onChange}
				/>
			</InlineEditInput>
		</InlineEdit>
	)
}
